module.exports = __webpack_public_path__ + "img/kommune-124.b3da56f7.svg";